import React, { useState} from "react";
import "./navbar.css";
import Modal from "react-bootstrap/Modal";
import Offcanvas from "react-bootstrap/Offcanvas";
import SideNavbar from "./sideNavbar";
import { Link, useNavigate } from "react-router-dom";
import { ModalHeader } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { resetUserInfo } from "../../../Features/userInfo";
import ProgressBar from "react-bootstrap/ProgressBar";

export default function Navbar() {
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackInfo, setFeedbackInfo] = useState({
    file: "",
    description: "",
    title: "",
  });
  const [uploadProgress] = useState(0);
  const [thumbnail, setThumbnail] = useState("");
  const [fileType, setFileType] = useState("");

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.user);

  const [notif] = useState([]);

 
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMegabytes = file.size / (1024 * 1024); // Convert bytes to megabytes
      if (fileSizeInMegabytes <= 50) {
        setFileType(file.type.split("/")[0]);
        setThumbnail(URL.createObjectURL(file));
        setFeedbackInfo({
          ...feedbackInfo,
          file: file,
        });
      } else {
        alert("File size exceeds 50MB. Please choose a smaller file.");
        e.target.value = ""; // Clear the file input
      }
    }
  };

  const navigate = useNavigate();
  const name = userInfo.fullName;
  const [avatar, setAvatar] = useState(false);
  const [email] = useState("");
  const words = name.split(" ");
  const initials = words.map((word) => word.charAt(0).toUpperCase());
  const nameIcon = initials.join("");

  const [show, setShow] = useState(false);
  const [navbar, setNavbar] = useState(false);
  const handleNavbarClose = () => setNavbar(false);
  const handleNavbarShow = () => setNavbar(true);
  const handleCloseAvatar = () => setAvatar(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logOut = () => {
    sessionStorage.clear();

    dispatch(resetUserInfo());

    navigate("/SignIn");

    setAvatar(false);
  };

  return (
    <>
      <div style={{ height: "56px" }}>
        <div className="navbarContainer">
          <div className="navMenu">
            <i className="bi bi-list" onClick={handleNavbarShow}></i>
            <Link to="/dashboard">
              <img src="./images/Logos/pvxLogo.svg" alt="logoIcon"></img>
            </Link>
          </div>
          <div className="navIcons">
            <div className="notificationIcon" onClick={handleShow}>
              {notif.length > 0 && <div className="ellipse1" />}
              <i className="bi bi-bell-fill"></i>
            </div>

            <div className="avatar" onClick={() => setAvatar(!avatar)}>
              <div className="ellipse2"></div>
              <h6> {nameIcon} </h6>
            </div>
          </div>
          <Modal
            show={show}
            onHide={handleClose}
            className="customerNotification"
          >
            <ModalHeader>Notifications</ModalHeader>
            <Modal.Body>
              {notif.map((notification, id) => {
                return (
                  <div key={id} className="newNotification">
                    <img src="./images/Logos/flash.svg" alt="logo" />
                    <div className="right">
                      <div className="head">
                        <p>{notification.designer}</p>
                        <i
                          // onClick={() => removeNotification(notification)}
                          className="bi bi-x"
                        />
                      </div>
                      <p>Order for {notification.siteName} is pending.</p>
                      <p className="date">{notification.date}</p>
                    </div>
                  </div>
                );
              })}
              {notif.length === 0 && (
                <div className="notificationBox">
                  <img src="./images/Logos/flash.svg" alt="logo"></img>
                  <p>No new notifications.</p>
                </div>
              )}
            </Modal.Body>
          </Modal>
          <Modal
            show={avatar}
            onHide={handleCloseAvatar}
            className="avatarModal"
          >
            <Modal.Body className="avatarInfo">
              <div className="upperInfo">{words[0]}</div>
              <div className="infoAvatar">{nameIcon}</div>
              <div className="lowerInfo">
                <h1>{name}</h1>
                {/* <h1>{userInfo.companyName}</h1> */}
                <h1>{email}</h1>
              </div>
              <div className="avatarSettings">
                {/* {userInfo.userType.toLowerCase() === "admin" && (
                  <Link to="/settings">
                    <h1>
                      <i className="bi bi-gear-fill"></i>Settings
                    </h1>
                  </Link>
                )} */}
                <h1 onClick={logOut}>
                  <i className="bi bi-power"></i>LogOut
                </h1>
              </div>
            </Modal.Body>
          </Modal>
          <Offcanvas
            show={navbar}
            onHide={handleNavbarClose}
            className="side-Navbar"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                <img src="../images/Logos/Logo.svg" alt="log"></img>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <SideNavbar></SideNavbar>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>

      {/* Session timeout modal */}
      {/* <Modal
        show={sessionTimedOut}
        onHide={() => {
          navigate("/SignIn");
          setSessionTimedOut(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        className="addProfileModal"
      >
        <Modal.Header>
          <Modal.Title className="title">
            Session expired. Please login again.
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-pair">
            <label className="label-name">Email ID</label>
            <input
              autoComplete="off"
              className="simple-inp"
              placeholder="john@gmail.com"
              value={emailVal}
              onChange={(e) => setEmailVal(e.target.value)}
              disabled={true}
            />
          </div>
          <div className="input-pair">
            <label className="label-name">Password</label>
            <div className="passwordInput">
              <input
                className="simple-inp"
                autoComplete="off"
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i
                className={
                  showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
                }
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="addProfileModelFooter">
          <Button
            className="button"
            variant="secondary"
            onClick={() => {
              logOut();
              setSessionTimedOut(false);
            }}
          >
            Logout
          </Button>
          <Button
            onClick={(e) => logIn(e)}
            className="button"
            variant="primary"
          >
            Login
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* Feedback Modal */}
      <Modal
        show={showFeedback}
        onHide={() => setShowFeedback(false)}
        backdrop="static"
        keyboard={false}
        centered
        className="featureModal"
      >
        <Modal.Body className="feature-show-model">
          <div>
            <div className="inputs">
              <h3 className="heading" style={{ marginBottom: "-10px" }}>
                Attachment
              </h3>
              <div
                className="logo"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div className="fileBox">
                  <input
                    id="img-upload"
                    placeholder="test"
                    type="file"
                    name="img"
                    aria-labelledby="Choose Attachment"
                    // accept="image/*, video/*"
                    onChange={
                      (e) => handleFileUpload(e)
                      // uploadTest(e)
                    }
                  />
                  <span>*Upload image or video file smaller than 50MB.</span>
                </div>
                {fileType === "video" && (
                  <>
                    <video
                      src={thumbnail}
                      // src={feedbackInfo.image ? feedbackInfo.image : ""}
                      alt="NoFeedbackImage"
                      style={{ width: "300px", maxHeight: "250px" }}
                    />
                    <ProgressBar
                      now={uploadProgress}
                      variant="warning"
                      animated
                      style={{ width: "300px" }}
                      striped
                      label={`${uploadProgress}%`}
                    />
                  </>
                )}
                {fileType === "image" && (
                  <>
                    <img
                      src={thumbnail}
                      // src={feedbackInfo.image ? feedbackInfo.image : ""}
                      alt="NoFeedbackImage"
                      style={{ width: "300px", maxHeight: "250px" }}
                    />
                    <ProgressBar
                      now={uploadProgress}
                      variant="warning"
                      animated
                      style={{ width: "300px" }}
                      striped
                      label={`${uploadProgress}%`}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="inputs">
              <h3
                className="heading"
                style={{ marginTop: "10px", marginBottom: "-10px" }}
              >
                Title
              </h3>
              <input
                type="text"
                className="inputField"
                name="description"
                value={feedbackInfo.title}
                // style={{ width: "100%", height: "100px" }}
                onChange={(e) =>
                  setFeedbackInfo({
                    ...feedbackInfo,
                    title: e.target.value,
                  })
                }
                placeholder="Feedback Title"
              />
            </div>
            <div className="inputs">
              <h3
                className="heading"
                style={{ marginTop: "10px", marginBottom: "-10px" }}
              >
                Description
              </h3>
              <textarea
                type="text"
                className="inputField"
                name="description"
                value={feedbackInfo.description}
                style={{ width: "100%", height: "100px" }}
                onChange={(e) =>
                  setFeedbackInfo({
                    ...feedbackInfo,
                    description: e.target.value,
                  })
                }
                placeholder="Describe your problem or suggestion in detail..."
              />
            </div>
          </div>

          <div className="button-pair">
            <button
              className="closeButton"
              onClick={() => setShowFeedback(false)}
            >
              Close
            </button>
            <button
              className="nextButton"
              // onClick={(e) => {
              //   submitFeedback(e);
              // }}
            >
              Submit Feedback
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
